import { Button, LuIcon } from "@overmap-ai/blocks"
import { Link } from "@tanstack/react-router"
import { memo } from "react"

import { modelIconMapping } from "../../mappings/icons"
import { BaseTopBar } from "../TopBars/BaseTopBar"

export const ProcedureTypeDetailViewTopBar = memo(() => {
	return (
		<BaseTopBar
			leftContent={
				<Link
					from="/$organizationId/$projectId/procedure-types/$procedureTypeId"
					to="/$organizationId/$projectId/procedure-types"
				>
					<Button variant="ghost" accentColor="base">
						<LuIcon icon={modelIconMapping.arrowLeft} />
						Procedures
					</Button>
				</Link>
			}
		/>
	)
})
ProcedureTypeDetailViewTopBar.displayName = "ProcedureTypeDetailViewTopBar"
